import { render, staticRenderFns } from "./Pro-Viande.vue?vue&type=template&id=c10d8230&scoped=true&"
import script from "./Pro-Viande.vue?vue&type=script&lang=js&"
export * from "./Pro-Viande.vue?vue&type=script&lang=js&"
import style0 from "./Pro-Viande.vue?vue&type=style&index=0&id=c10d8230&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10d8230",
  null
  
)

export default component.exports